module.exports = __webpack_public_path__ + "img/21.dd668fc4.jpg";